<template>
  <div class="user-creditCard">
    <div class="userTitle1">
      <span class="iconfont iconjianshao">
        <svg
          width="20"
          height="20"
          viewBox="0 0 46 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M29.6469 23.023C30.5439 23.023 31.2799 22.287 31.2799 21.39C31.2799 20.493 30.5439 19.757 29.6469 19.757H24.6559V19.688L30.7509 13.34C31.3719 12.673 31.3719 11.638 30.7049 11.017C30.0609 10.396 29.0259 10.419 28.3819 11.063L23.1609 16.537L17.6409 11.04C16.9969 10.396 15.9619 10.396 15.3179 11.04C14.6739 11.684 14.6509 12.719 15.2949 13.363L21.3669 19.458V19.757H16.5139C15.6169 19.757 14.8809 20.493 14.8809 21.39C14.8809 22.287 15.6169 23.023 16.5139 23.023H21.3669V26.312H16.5139C15.6169 26.312 14.8809 27.048 14.8809 27.945C14.8809 28.842 15.6169 29.578 16.5139 29.578H21.3669V34.454C21.3669 35.351 22.1029 36.087 22.9999 36.087C23.8969 36.087 24.6329 35.351 24.6329 34.454V29.578H29.6239C30.5209 29.578 31.2569 28.842 31.2569 27.945C31.2569 27.048 30.5209 26.312 29.6239 26.312H24.6329V23.023H29.6469ZM44.3439 9.38402H32.2459C31.3259 9.38402 30.5899 8.64802 30.5899 7.72802C30.5899 6.80802 31.3259 6.07202 32.2459 6.07202H44.3439C45.2639 6.07202 45.9999 6.80802 45.9999 7.72802C45.9999 8.62502 45.2639 9.38402 44.3439 9.38402Z"
              fill="#fff"
            />
            <path
              d="M23 46C10.327 46 0 35.673 0 23C0 10.327 10.327 0 23 0V3.45C12.213 3.45 3.45 12.213 3.45 23C3.45 33.787 12.213 42.55 23 42.55C33.787 42.55 42.55 33.787 42.55 23H46C46 35.673 35.673 46 23 46Z"
              fill="#fff"
            />
            <path
              d="M42.5498 23C42.5498 23.4575 42.7315 23.8963 43.055 24.2198C43.3785 24.5433 43.8173 24.725 44.2748 24.725C44.7323 24.725 45.1711 24.5433 45.4946 24.2198C45.8181 23.8963 45.9998 23.4575 45.9998 23C45.9998 22.5425 45.8181 22.1038 45.4946 21.7803C45.1711 21.4568 44.7323 21.275 44.2748 21.275C43.8173 21.275 43.3785 21.4568 43.055 21.7803C42.7315 22.1038 42.5498 22.5425 42.5498 23V23Z"
              fill="#fff"
            />
            <path
              d="M21.2754 1.725C21.2754 2.1825 21.4571 2.62126 21.7806 2.94476C22.1041 3.26826 22.5429 3.45 23.0004 3.45C23.4579 3.45 23.8966 3.26826 24.2201 2.94476C24.5436 2.62126 24.7254 2.1825 24.7254 1.725C24.7254 1.2675 24.5436 0.828741 24.2201 0.505241C23.8966 0.181741 23.4579 0 23.0004 0C22.5429 0 22.1041 0.181741 21.7806 0.505241C21.4571 0.828741 21.2754 1.2675 21.2754 1.725V1.725Z"
              fill="#fff"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="46" height="46" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
      在线取款
    </div>
    <div class="count">
      <div class="userInputs">
        <div class="userInput">
          *选择提款方式：
          <el-select
            popper-class="userSelect"
            size="medium"
            v-model="backcardname"
            value-key="number"
            placeholder="请选择收款方式"
            @change="onSelectbank"
          >
            <template slot="prefix">
              <!-- <img v-if="bankObj.type == 2"
                                class="prefixUrl"
                                src="../../static/img/wallet.png"
                            />
                              <img v-else
                                v-show="bankObj.imgUrl"
                                class="prefixUrl"
                                :src="$common.getImgUrl(bankObj.imgUrl)"
                            /> -->
            </template>
            <el-option
              v-for="item in bankArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <!-- <img v-if="item.type == 2"
                                class="banicon"
                                src="../../static/img/wallet.png"
                            />
                             <img v-else
                                class="banicon"
                                :src="$common.getImgUrl(item.imgUrl)"
                            /> -->
              <span v-if="item.type == 2">origo钱包{{ item.name }}</span>
              <span v-else>{{ item | banktitle }}</span>
            </el-option>
          </el-select>
        </div>

        <div class="userInput">
          *提款金额：
          <el-input
            size="medium"
            v-model="gold"
            type="number"
            onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
            clearable
            placeholder="请输入金额"
            @input="onMoneyBlur"
          ></el-input>
        </div>
        <div class="userInput">
          *交易密码：
          <el-input
            size="medium"
            v-model="passworld"
            show-password
            placeholder="请输入密码"
          ></el-input>
        </div>
        <div class="tipsBox">
          <p class="tips-text-ele themeTextColor" v-if="bankObj.type == 0">
            实际到账金额：￥{{ $common.setNumFixed(ActualMoney, 2) }}
            <img
              src="../../static/img/refresh.png"
              class="refresh-img cursorPoint"
              fit="fit"
              @click="getCost(true)"
            />
          </p>
          <p class="tips-text-ele themeTextColor" v-if="bankObj.type != 0">
            实际到账金额：￥{{ $common.setNumFixed(ActualMoney, 2) }}RMB≈
            {{ exchange === 0 ? "0.000000" : accMul(ActualMoney, exchange)
            }}{{ currencyName }}
            <img
              src="../../static/img/refresh.png"
              class="refresh-img cursorPoint"
              fit="fit"
              @click="getCost(true)"
            />
          </p>
          <p v-if="bankObj.type != 0" class="tips-text-ele">
            1RMB≈ {{ exchange }}{{ currencyName }}
          </p>
          <p class="tips-text-ele">
            提现手续费：￥{{ $common.setNumFixed(handlingfee, 2) }}
          </p>
          <p class="tips-text-ele">
            行政费用：￥{{ $common.setNumFixed(administrativeCosts, 2) }}
          </p>
          <p class="tips-text-ele">
            优惠扣除：￥{{ $common.setNumFixed(discountDeduction, 2) }}
          </p>
        </div>
        <div class="button">
          <span class="btnUser1" @click="onConfirm">提交</span>
        </div>
      </div>
      <div class="gamelistbox">
        <div class="info">
          账号：{{ userName }} <span>余额：￥{{ userInfo.totalBalance }}</span>
          <label class="btnUser1" @click="getOneG">一键归集</label>
        </div>
        <ul class="gamelist">
          <li v-for="game in userInfo.totalBalanceDetail" :key="game.vendorId">
            {{ game.vendorName }}
            <p>{{ game.totalMoney.toFixed(2) }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  filters: {
    subNum(val) {
      var re = /([0-9]+\.[0-9]{6})[0-9]*/;
      let aNew = (val + "").replace(re, "$1");
      return aNew;
    },
    banktitle(val) {
      if (val) {
        return val.name + "(" + val.number.substr(-4) + ")";
      } else {
        return;
      }
    },
  },
  data() {
    return {
      gold: "",
      passworld: "",
      bankObj: {
        type: 0,
      },
      backImg: "",
      userName: "",
      balance: "0.00",
      handlingfee: 0, //手续费
      administrativeCosts: 0, //行政费用,
      discountDeduction: 0, //优惠扣除
      singleMax: 0,
      singleMin: 0,
      ActualMoney: 0, //实际到账金额
      exchange: "", //汇率
      digitBuyRate: "", //转换前的汇率
      currencyName: "", //货币名称
      calculate: "", //计算最小提现金额
      actualAmount: "", //实际到账金额
      backcardname: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo", "bankArr"]),
  },

  mounted() {
    this.$http
      .get(this.$api.members + "/" + this.$common.getUser().user_id, "", true)
      .then((res) => {
        if (!res.data.withdrawPassWordState) {
          this.$alert("请先设置交易密码?", "提示", {
            type: "warning",
            showClose: false,
            callback: (action) => {
              this.$router.push({ path: "/user/modifyWithPsw" });
            },
          });
          return
        }
        if (!res.data.realName) {
          this.$alert("请先设置真实姓名再添加银行卡?", "提示", {
              type: "warning",
              showClose: false,
              callback: (action) => {
              this.$router.push({ path: "/user/info" });
              },
          });
          return
        }
        if (!res.data.phone) {
          this.$alert("请先绑定手机号再添加银行卡?", "提示", {
              type: "warning",
              showClose: false,
              callback: (action) => {
              this.$router.push({ path: "/user/info" });
              },
          });
          return
        }
      });

    this.userName = this.$common.getUser().username;
    var balanceFull = this.$common.getUserBalance();
    if (balanceFull) {
      this.balance = balanceFull.totalBalance.toFixed(2);
    }
    this.gameList = this.userInfo.totalBalanceDetail;
    this.getCost();
    // this.getGameMoneyList();
  },
  methods: {
    //金额输入框改变onChange
    onMoneyBlur(e) {
      console.log(e, this.gold);
      this.gold = this.gold.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      if (e) {
        e = e.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
        this.ActualMoney =
          e -
          this.handlingfee -
          this.administrativeCosts -
          this.discountDeduction;
      } else {
        this.ActualMoney = 0;
      }
      if (this.ActualMoney <= 0) {
        this.ActualMoney = 0;
      }
    },
    //一键归集
    getOneG() {
      this.$nkhttp.oneKeyBalance();
    },
    // 获取汇率
    getDigitRate() {
      console.log("获取汇率", this.bankObj);
      if (this.bankObj.type == 0) {
        return;
      }
      let data = {
        digitCcy: this.bankObj.name,
        digitLink: this.bankObj.branch,
        type: this.bankObj.type,
      };
      this.$http.post(this.$api.getDigitRate, data).then((res) => {
        if (res.code == 0) {
          this.digitBuyRate = res.data.digitBuyRate;
          this.exchange = this.subNum6(1 / res.data.digitBuyRate);
          this.currencyName = res.data.digitCcy;
        } else {
          this.exchange = 0;
          this.currencyName = this.bankObj.name;
        }
      });
    },
    onSelectbank(e) {
      let backitemdata = this.bankArr.filter((item) => {
        return item.id == e;
      });
      this.bankObj = backitemdata[0];
      if (backitemdata[0].type == 2) {
        this.backcardname = "origo钱包(" + backitemdata[0].name + ")";
        // this.backImg = this.walletimg;
      } else {
        // this.backImg = this.$common.getImgUrl(backitemdata[0].imgUrl);
      }
      if (this.bankObj.type != 0) {
        this.getDigitRate();
      }
    },
    //小數點截取6位
    subNum6(val) {
      var re = /([0-9]+\.[0-9]{6})[0-9]*/;
      let aNew = (val + "").replace(re, "$1");
      return aNew;
    },
    //获取手续费等
    getCost(start = false) {
      let option = {
        memberId: this.$common.getUser().user_id,
      };
      this.$http.post(this.$api.getCurrentAudit, option).then((res) => {
        if (res.code == 0) {
          this.handlingfee = res.data.handlingfee; //手续费
          this.administrativeCosts = res.data.administrativeCosts; //行政费用,
          this.discountDeduction = res.data.discountDeduction; //优惠扣除
          this.singleMin = res.data.singleMin;
          this.singleMax = res.data.singleMax;
          if (start) {
            this.ActualMoney =
              this.gold -
              this.handlingfee -
              this.administrativeCosts -
              this.discountDeduction;
            if (this.ActualMoney < 0) {
              this.ActualMoney = 0;
            }
          }
        }
      });
    },
    onConfirm() {
      if (this.bankObj == "") {
        this.$message.error("请填写提款金额");
        return;
      }
      let _gold = parseFloat(this.gold);
      if (this.gold == "") {
        this.$message.error("请填写提款金额");
        return;
      }
      if (_gold > this.singleMax) {
        this.$message.error("您的提款金额超出最大提款金额:" + this.singleMax);
        return;
      }
      if (_gold < this.singleMin) {
        this.$message.error("您的提款金额低于最小提款金额:" + this.singleMin);
        return;
      }

      // if (_gold > this.userInfo.totalBalance) {
      //     this.$message.error("您的提款金额超出最大提款金额");
      //     return;
      // }
      // if (_gold < 0) {
      //     this.$message.error("您的提款金额低于最小提款金额");
      //     return;
      // }

      if (this.passworld == "") {
        this.$message.error("请填写资金密码");
        return;
      }
      this.$freeze.freeze().then((res) => {
        if (!res) {
          this.$message({
            message: "您的钱包已被冻结，请联系客服！",
            type: "error",
            duration: "2000",
          });
        } else {
          var _obj = {
            amount: _gold,
            operator: this.userInfo.name,
            bankNo: this.bankObj.number,
            bankAccount: this.bankObj.account, //银行卡户名
            bankBranch: this.bankObj.branch, //	支行
            bankName: this.bankObj.name, //银行名称
            password: this.passworld,
            handlingfee: this.handlingfee, //手续费
            administrativeCosts: this.administrativeCosts, //行政费用,
            discountDeduction: this.discountDeduction, //优惠扣除
            type: this.bankObj.type,
            digitRate: this.digitBuyRate,
            bankId: this.bankObj.id,
          };
          this.$nkhttp.http(this.$api.entranceWithdraw, _obj, "post", () => {
            this.$alert("申请成功，请等待平台审核", "提示", {
              confirmButtonText: "确定",
            });
          });
        }
      });
    },
    //计算数字精度
    accMul(arg1, arg2) {
      var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
      try {
        m += s1.split(".")[1].length;
      } catch (e) {}
      try {
        m += s2.split(".")[1].length;
      } catch (e) {}
      return (
        (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
        Math.pow(10, m)
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.user-creditCard {
  .tipsBox {
    text-align: right;
    .tips-text-ele {
      line-height: 2;
      font-size: 0.13rem;
      color: #666;
    }
    .refresh-img {
      width: 25px;
      height: 25px;
      cursor: pointer;
    }
  }
  .count {
    display: flex;
    .userInputs {
      margin-left: 65px;
      margin-top: 105px;
      .userInput {
        width: 400px;
      }
      .button {
        padding-top: 30px;
        padding-left: 170px;
      }
    }
    .gamelistbox {
      .info {
        font-size: 14px;
        line-height: 82px;
        margin-bottom: 20px;
        span {
          margin-left: 30px;
        }
        label {
          margin-left: 60px;
        }
      }
      margin-left: 65px;
      overflow-y: auto;
      .gamelist {
        display: flex;
        padding-right: 20px;
        flex-wrap: wrap;
        li {
          text-align: center;
          font-size: 16px;
          color: #222;
          width: 150px;
          background-color: #f4f4f4;
          margin-right: 30px;
          padding: 10px 0;
          box-sizing: border-box;
          margin-bottom: 10px;
          p {
            font-weight: bold;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>